import { useDataTable } from "@/lib/hooks/use-data-table.ts";
import { DataTable } from "@/components/data-table/data-table.tsx";
import { columns } from "./columns.tsx";
import { MentorshipFeedback } from "@/lib/api/mentorships.ts";

interface HistoryProps {
  data: MentorshipFeedback["teenWellBeing"]["history"];
}

export const History = ({ data }: HistoryProps) => {
  const { table } = useDataTable({
    columns: columns,
    data: data || [],
    defaultPerPage: 10,
    pageCount: -1,
    filterFields: [],
    disablePagination: true,
  });

  return (
    <div>
      <DataTable
        table={table}
        disablePagination
        tableContainerClassName="h-[250px] overflow-y-auto"
      />
    </div>
  );
};
